import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'bold',
  standalone: false
})
export class BoldPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, keywords: string[]): SafeHtml {
    if (!value || !keywords || keywords.length === 0) {
      return this.sanitizer.bypassSecurityTrustHtml(value);
    }

    let replacedValue = value;

    // Sort keywords by length in descending order to prevent partial matching issues
    keywords.sort((a, b) => b.length - a.length);

    keywords.forEach(word => {
      if (word.trim() !== '') {
        // Use a global, case-insensitive regular expression to find all occurrences
        // Escaping special characters in the word for safe regex creation
        const escapedWord = word.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regex = new RegExp(`(${escapedWord})`, 'gi');
        replacedValue = replacedValue.replace(regex, '<strong>$1</strong>');
      }
    });

    // Sanitize the resulting HTML before rendering to prevent XSS attacks
    return this.sanitizer.bypassSecurityTrustHtml(replacedValue)
  }
}